import { Component, Input} from '@angular/core';
import { EveReportingWidget } from '../widget.component';




@Component({
  selector: 'text-widget',
  templateUrl: 'text-widget.component.html',
  styleUrls: ['./text-widget.component.css']
})
export class TextWidgetComponent {

  @Input()
  widget?: EveReportingTextWidget = null;


  constructor(
    
  )
  {

  }


}


export interface EveReportingTextWidget extends EveReportingWidget {
  text: string;
}
